module.exports = __webpack_public_path__ + "static/pages-943d6918fdf3008791278f220b413b48.webp";